import React, { useEffect, useState } from 'react';
import { Select, Loader } from '@pwc/pwc-deals-ui';
import { getPowerPointSlides } from '../../sharePointService';
import { ErrorAction } from './PowerPointIngestionErrorHandling';
import { useIngestionErrors } from './IngestionErrorProvider';

const generateSlideOptions = (slides) => {
  return slides.map((pptSlide, index) => ({
    value: pptSlide.slideNumber,
    key: `${pptSlide}-${index}`,
  }));
};

const PowerPointSlideNumber = ({
  pptFiles,
  fileName,
  slideNumber,
  setSlideNumber,
  setSharePointItemUrl,
  projectId,
  setGroupName,
  ingestedPowerPointGroups,
  setSlides,
  selectedFileOption,
  setIsSlideListLoading,
  isSlideListLoading,
}) => {
  const [errorState, errorDispatch] = useIngestionErrors();
  const [slideOptions, setSlideOptions] = useState([]);

  useEffect(() => {
    const getSlides = async () => {
      if (selectedFileOption) {
        setIsSlideListLoading(true);
        const url = `${selectedFileOption.driveUrl}/${selectedFileOption.fileName}`;
        setSharePointItemUrl(url);
        try {
          const newSlideList = await getPowerPointSlides(
            projectId,
            selectedFileOption.driveId,
            selectedFileOption.driveItemId
          );
          setSlides(newSlideList);
          if (newSlideList.length === 0) {
            errorDispatch(ErrorAction.NoSlidesInPowerPointFileError);
          } else {
            setSlideOptions(generateSlideOptions(newSlideList));
          }
        } catch (exception) {
          errorDispatch(ErrorAction.FailedRetrievingPowerPointSlides);
        }
        setIsSlideListLoading(false);
      } else {
        setSharePointItemUrl('');
        setSlideOptions([]);
      }
    };

    getSlides();
  }, [
    projectId,
    pptFiles,
    fileName,
    ingestedPowerPointGroups,
    setSlides,
    selectedFileOption,
    setSharePointItemUrl,
    errorDispatch,
    setIsSlideListLoading,
  ]);

  const handleSlideNumberChange = (value) => {
    errorDispatch(ErrorAction.Clear);
    setSlideNumber(value);
    setGroupName('');
  };

  const slideNumberField = {
    name: 'slideNumber-select',
    value: slideNumber,
    onChange: (event) => handleSlideNumberChange(event.target.value),
  };

  return isSlideListLoading ? (
    <Loader dataTestId="powerpoint-slide-list-loader" />
  ) : (
    <Select
      field={slideNumberField}
      label="Slide number"
      placeholder="Select slide number"
      data-testid="slideNumber-select"
      options={slideOptions}
      value={slideNumber}
      disabled={!fileName}
      onChange={(evt) => handleSlideNumberChange(evt.target.value)}
      error={errorState.slideNumberError}
    />
  );
};

export default PowerPointSlideNumber;
